import {
  DefaultsDocument,
  UserProfileAddCcDocument,
  UserProfileAddCcMutationVariables,
  UserProfileDocument,
  ValpayConfigDocument,
} from "@graphql/api";

export default async function userProfileAddCc(
  ccNumber: string,
  ccExpiration: string,
  ccName: string,
  ccPostalCode?: string,
  ccAddress?: string,
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileAddCcMutationVariables = {
    ccNumber,
    ccExpiration,
    ccName,
    ccPostalCode,
    ccAddress,
  };

  const result = await client.mutate({
    mutation: UserProfileAddCcDocument,
    variables: mutVars,
    // Refetch only the queries that display credit card data
    refetchQueries: [
      { query: UserProfileDocument },
      { query: DefaultsDocument },
      { query: ValpayConfigDocument },
    ],
    awaitRefetchQueries: true,
  });

  return result.data?.userProfileAddCc.success ?? false;
}
